package ui.app.rss

import androidx.compose.runtime.*
import compose.assets.*
import compose.assets.svg.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tools.*

@Stable
class AppRssListingScope(
    val nav: Navigation,
    val args: AppRssListingArgs,
    val vm: AppRssListingVM,
    val tabs: List<TabEntry<Node>>
) {
    companion object {
        @Composable
        fun remember(): AppRssListingScope {
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current.rememberArgs(AppRssListingArgs::class)
            val vm = nav.viewModel(AppRssListingVM::class)

            return remember {
                val tabs = buildTabs(args, vm)
                vm.init(tabs)

                AppRssListingScope(
                    nav = nav,
                    args = args,
                    vm = vm,
                    tabs = tabs
                )
            }
        }

        private fun buildTabs(args: AppRssListingArgs, vm: AppRssListingVM): List<TabEntry<Node>> {
            return buildList {
                val onClick: (TabEntry<Node>) -> Unit = {
                    vm.selectTab(it)
                }
                add(
                    TabEntry(
                        icon = Svg.Lan,
                        label = Res.string.layer_bottom_rss_tab_instances,
                        onClick = onClick,
                        args = args.asBundle(),
                        tag = Node.AppRssListingInstanceUI
                    )
                )
                add(
                    TabEntry(
                        icon = Svg.Database,
                        label = Res.string.layer_bottom_rss_tab_channels,
                        onClick = onClick,
                        args = args.asBundle(),
                        tag = Node.AppRssListingChannelUI
                    )
                )
            }
        }
    }
}
